import "./styles.css";
import { LiveOracleStubSource } from "./live/stub-source";
import { SimulationEngine } from "./sim/engine";
import { AppUI } from "./ui/app";
import { CityWorld } from "./world/city";
import { FlowVisualizer } from "./world/flow-visualizer";

const root = document.querySelector<HTMLElement>("#app");
if (!root) {
  throw new Error("OraCity could not find the application root.");
}

const engine = new SimulationEngine();
engine.setAutoAdvance(false);
engine.run("ore");
const liveSource = new LiveOracleStubSource();
const ui = new AppUI(root, engine, liveSource);

const canvas = document.querySelector<HTMLCanvasElement>("#city-canvas");
const labels = document.querySelector<HTMLElement>("#city-labels");
if (!canvas || !labels) {
  throw new Error("OraCity could not initialize the 3D city.");
}

const world = new CityWorld(canvas, labels);
const flowVisualizer = new FlowVisualizer(world);
world.bindInterior(
  (state) => ui.showInterior(state),
  (text) => ui.showInteriorFocus(text),
);
ui.bindExhibitControls(
  (options) => world.setExhibitOptions(options),
  (mode) => world.setInteriorMode(mode),
);
ui.bindTourControls((guided) => world.setTourEnabled(guided));
ui.bindCityViewControls((expanded) => {
  world.setImmersiveView(expanded);
  flowVisualizer.update(engine.snapshot());
});

engine.subscribe((snapshot) => {
  ui.render(snapshot);
  flowVisualizer.update(snapshot);
});

world.start((deltaMs) => engine.tick(deltaMs));

// A reduced-motion preference keeps the initial lesson still and self-paced.
if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  engine.togglePause();
}

Object.assign(window, {
  ORACITY: {
    engine,
    liveSource,
    world,
  },
});
